import { SocialAuthProps } from './social-auth'
import { SocialProvider } from '@dtx-company/true-common/src/types/socialProvider'
import { User } from '../../types/user'

export type AuthFormProps = {
  onSubmit: (user: User, provider: SocialProvider, flowpageSlug?: string) => Promise<void> | void
  isSignIn?: boolean
  slug?: string
  onToggleMode?: () => void
} & Pick<SocialAuthProps, 'showFacebookBtn'>

export enum AuthFormFields {
  SLUG = 'slug',
  EMAIL = 'email',
  PASSWORD = 'password',
  NO_MARKETING_EMAILS = 'noMarketingEmails',
  TERMS = 'terms'
}

export const PASSWORD_REGEX = /.*?(.)\1{2,}.*/

export type UseAuthFormHeapEventsReturnType = {
  userTypedInAuthFormEmailField: () => void
  userTypedInAuthFormPasswordField: () => void
  userFocusedAuthFormField: (isSignIn: boolean, fieldName: string) => void
  userClickedAuthFormAuthenticateWithSocial: (provider: SocialProvider) => void
  userClickedAuthFormForgotPassword: () => void
  userClickedAuthFormSubmitButton: (options?: { sso?: boolean }) => void
  userCheckedAuthFormIAgreeToTermsAndConditions: () => void
  userClickedAuthFormTermsAndConditionsLink: () => void
}
